import React from "react";
import FormElement, { FormElementProps } from "../forms/common/FormElement";
import TextField, { TextProps } from "../formx/Text";

type Props = FormElementProps & TextProps;

export const Text: React.FC<Props> = (props) => {
  const { label, TextFieldProps: textFieldProps, helperText, disabled, ...rest } = props;

  return (
    <FormElement
      required={props.required}
      field={
        <TextField
          name={props.name}
          label={props.label}
          TextFieldProps={{ ...textFieldProps }}
          helperText={helperText}
          disabled={disabled}
        />
      }
      id={rest.name}
      {...rest}
    />
  );
};
